import {twMerge} from "tailwind-merge";

export default function NumberInput({classes = {}, value, onChange, min = 1, max, ...otherProps}) {

    const {parentClasses = "", inputClasses} = classes;

    const changeHandler = (increase) => {
        if (increase) {
            if (!max || value + 1 <= max) {
                onChange(Number(value) + 1)
            }
        } else {
            if (value - 1 >= min) {
                onChange(Number(value) - 1)
            }
        }
    }

    return (
        <div
            className={twMerge("bg-pol-light-7 border border-pol-gray-light-3 rounded-[0.875rem] flex items-center justify-between gap-x-3 px-3.5 w-[12.625rem] text-pol-gray", parentClasses)}>
            <button
                type="button"
                onClick={changeHandler}
            >
                <span className="text-xl">+</span>
            </button>
            <input
                className={twMerge("focus:outline-none text-center flex-grow py-2.5 bg-pol-light-7 hover:border-pol-blue flex-grow", inputClasses)}
                value={value}
                inputMode="numeric"
                type="number"
                onChange={({target}) => onChange(target.value)}
                {...otherProps}
            />
            <button
                type="button"
                onClick={() => changeHandler(0)}
            >
                <span className="text-xl">-</span>
            </button>
        </div>
    )
}
